import INVITE_FRIEND from './invite-friend/types';
import CUSTOMER_OVERVIEW_TYPES from './customer-overview/types';

export default {
  ...INVITE_FRIEND,
  ...CUSTOMER_OVERVIEW_TYPES,
};
